import { useEffect, useState } from "react";
import * as yup from "yup";

import {
  useHookForm,
  useMerchantApiMutation,
  useMerchantApiQueryWithParams,
  useReactRouterLink,
} from "../../../hooks";
import {
  IAppendBankAccountTag,
  IHookForm,
  IModalFormProps,
  IViewBankAccountTag,
} from "../../../interfaces-and-types";
import { globalHandlerUtils } from "../../../utils";

import { View } from "./View";
import { useParams } from "react-router-dom";

export interface IBankAccountTagFormViewProps
  extends IHookForm<IAppendBankAccountTag> {
  formValues: IAppendBankAccountTag;
  closeModal: () => void;
}

export const BankAccountTagForm = () => {
  const { bank_account_id = "" } = useParams();
  const { location, navigate } = useReactRouterLink();

  // const {
  //   isLoading: isLoadingBankAccounts,
  //   isError: isErrorBankAccounts,
  //   data: bankAccounts,
  //   meta: bankAccountsMeta,
  //   refetch: refetchBankAccounts,
  // } = useMerchantApiQueryWithParams<
  //   IBankAccountQueryMeta,
  //   IViewBankAccount
  // >(["getBankAccount", {
  //   id: bank_account_id
  // }]);

  const {
    isSuccess: isSuccessSaveBankAccountTag,
    mutate: appendBankAccountTag,
  } = useMerchantApiMutation<IAppendBankAccountTag, IViewBankAccountTag>(
    "appendBankAccountTag",
    ["getBankAccounts"]
  ).usePostMutation;

  const closeModal = () =>
    navigate(location.pathname.split(`${bank_account_id}/tags/append`)[0]);

  useEffect(() => {
    if (isSuccessSaveBankAccountTag) {
      reset();
      closeModal();
    }
  }, [isSuccessSaveBankAccountTag]);

  const initialFormValues: IAppendBankAccountTag = {
    bank_account_id,
    tag_name: "",
    description: null,
  };

  const saveBankAccountSchema: yup.SchemaOf<IAppendBankAccountTag> = yup
    .object({
      bank_account_id: yup.string().required("Bank account id is required"),
      tag_name: yup.string().required("Tag name is required"),
      description: yup.string().nullable().optional(),
    })
    .required();

  const handleApiSubmit = (data: IAppendBankAccountTag) => {
    appendBankAccountTag(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, errors, register, reset, control, watch } = useHookForm(
    {
      initialFormValues,
      validationSchema: saveBankAccountSchema,
      onValid: handleApiSubmit,
      onInvalid: handleError,
    }
  );

  const formValues = watch();

  return (
    <View
      closeModal={closeModal}
      formValues={formValues}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
      control={control}
    />
  );
};
